/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Category
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Category
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Category
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof Category
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    parentId?: string | null;
    /**
     * 
     * @type {Category}
     * @memberof Category
     */
    parent?: Category;
    /**
     * 
     * @type {Array<Category>}
     * @memberof Category
     */
    children?: Array<Category> | null;
    /**
     * 
     * @type {Array<Order>}
     * @memberof Category
     */
    orders?: Array<Order> | null;
}

/**
 * Check if a given object implements the Category interface.
 */
export function instanceOfCategory(value: object): value is Category {
    return true;
}

export function CategoryFromJSON(json: any): Category {
    return CategoryFromJSONTyped(json, false);
}

export function CategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Category {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'description': json['description'] == null ? undefined : json['description'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'parent': json['parent'] == null ? undefined : CategoryFromJSON(json['parent']),
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(CategoryFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderFromJSON)),
    };
}

export function CategoryToJSON(json: any): Category {
    return CategoryToJSONTyped(json, false);
}

export function CategoryToJSONTyped(value?: Category | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'code': value['code'],
        'name': value['name'],
        'fullName': value['fullName'],
        'description': value['description'],
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'parentId': value['parentId'],
        'parent': CategoryToJSON(value['parent']),
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(CategoryToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderToJSON)),
    };
}

